module.exports = __webpack_public_path__ + "assets/HKNova-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Bold.woff
// module id = 144
// module chunks = 0